"use client";
import Title from "@/components/ui/title";
import { DirectusImage } from "@/components/DirectusImage";
import { useScopedI18n } from "@/messages/client";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  type CarouselApi,
} from "@/components/ui/carousel";
import { cn } from "@/lib/utils";
import { useCallback, useEffect, useState } from "react";

export default function CaseTechnical(
  props: {
    data?: {
      description?: string;
      summary?: string;
      images?: {
        directus_files_id: string;
      }[];
    }
  }
) {
  const t = useScopedI18n("应用");
  const [current, setCurrent] = useState(0);
  const [mainApi, setMainApi] = useState<CarouselApi | null>(null);
  const [scrollSnaps, setScrollSnaps] = useState<number[]>([]);

  const onSelect = useCallback(() => {
    if (!mainApi) {
      return;
    }
    setCurrent(mainApi.selectedScrollSnap() || 0);
  }, [mainApi]);

  useEffect(() => {
    if (!mainApi) {
      return;
    }
    setScrollSnaps(mainApi.scrollSnapList());

    mainApi.on("reInit", () => {
      setScrollSnaps(mainApi.scrollSnapList());
    });
  }, [mainApi]);

  useEffect(() => {
    if (!mainApi) {
      return;
    }
    onSelect();
    mainApi.on("select", onSelect).on("reInit", onSelect);
  }, [mainApi, onSelect]);
  return (
    <div className="w-full">
      <Title className="md:items-start md:text-left" title={t("技术分析")} underline={false} />
      <div className="flex flex-col items-start gap-y-5 mt-3 md:flex-row md:gap-x-24 md:mt-4">
        <div className="flex-auto whitespace-pre-line text-sm md:text-base md:text-gray md:leading-7">
          {props.data?.description}
        </div>
        <div className="relative shrink-0 px-6 py-5 text-sm bg-zinc-100 rounded md:w-[370px] md:px-7 md:py-6 md:leading-7">
          <img
            className="absolute right-6 bottom-5 w-8 md:right-10 md:-bottom-2"
            src="/icon/quotes.svg"
            alt="Icon Quotes"
          />
          <p className="relative z-[1]">{props.data?.summary}</p>
        </div>
      </div>
      <div className="w-full mt-5 md:mt-16">
        <Carousel
          className="w-full"
          opts={{ loop: true }}
          setApi={setMainApi}
        >
          <CarouselContent className="-ml-2">
            {props.data?.images?.map((el, index) => (
              <CarouselItem
                className="pl-2 basis-full md:basis-1/2"
                key={index}
              >
                <DirectusImage
                  id={el.directus_files_id}
                  alt={`${t("技术分析")} ${index + 1}`}
                  width={580}
                  height={326}
                  className="rounded-xl"
                />
              </CarouselItem>
            ))}
          </CarouselContent>
          <div className="mt-4 flex w-full items-center justify-center space-x-2 md:hidden">
            {scrollSnaps.map((_, index) => (
              <div
                key={index}
                className={cn(
                  "h-1.5 w-1.5 rounded-full bg-[#CCCCCC] transition-all duration-300 ease-in-out",
                  {
                    "w-4 bg-[#2C2C2C]": current === index,
                  }
                )}></div>
            ))}
          </div>
        </Carousel>
      </div>
    </div>
  )
}